export enum YougovDatumResponseTypes {
    Single = 'single',
    Date = 'date',
    Open = 'open',
    Multiple = 'multiple',
}
